import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import VueTouch from 'vue-touch'
//import {sync} from 'vuex-router-sync'
import locale from 'element-ui/lib/locale/lang/zh-TW'

import Ads from 'vue-google-adsense'
import VuePusher from 'vue-pusher';

Vue.use(require('vue-script2'))

Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.use(ElementUI, { locale })

import '../css/all.scss'

Vue.use(ElementUI);
Vue.use(require('vue-moment'));
Vue.use(VueTouch, {name: 'v-touch'})
Vue.config.productionTip = false

Vue.use(VuePusher, {
    api_key: 'e6137bca3d42d7e3f687',
    options: {
        cluster: 'ap3',
        encrypted: true,
    }
});

new Vue({
  router,
  store,
    data:{
      shoppingCarCount:0
    },
  render: h => h(App)
}).$mount('#app')
